import { render, staticRenderFns } from "./RightPerfil.vue?vue&type=template&id=29c6c5f3"
import script from "./RightPerfil.vue?vue&type=script&lang=js"
export * from "./RightPerfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports